import { render } from "./listadodocumentacion.vue?vue&type=template&id=43592640&scoped=true"
import script from "./listadodocumentacion.vue?vue&type=script&lang=js"
export * from "./listadodocumentacion.vue?vue&type=script&lang=js"

import "./listadodocumentacion.vue?vue&type=style&index=0&id=43592640&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43592640"]])

export default __exports__